import { ShoppingCartAccessory } from './shopping-cart-accessory';

export class ShoppingCartProductAccessory {
  accessoryId: string;
  accessory: ShoppingCartAccessory;
  quantity?: number;
  tva?: number;

  constructor(accessory: ShoppingCartAccessory, quantity: number, tva: number) {
    this.accessory = accessory;
    this.quantity = quantity;
    (this.tva = tva), (this.accessoryId = accessory.id);
  }
}
